module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('scene', {
    attrs: {
      "id": "scene",
      "product": _vm.product
    }
  }), _vm._v(" "), (_vm.showOrderForm) ? _c('order-form', {
    attrs: {
      "productSummary": _vm.productSummary,
      "id": "order-form"
    },
    on: {
      "alert": _vm.onOrderFormAlert,
      "close": function($event) {
        _vm.showOrderForm = false
      },
      "confirm": _vm.confirmOrder
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "id": "configuration-panel"
    }
  }, [_c('component-type-selector', {
    attrs: {
      "id": "component-type-selector",
      "productType": _vm.product.type,
      "componentTypeDict": _vm.productSummary.components,
      "targetComponentType": _vm.targetComponent && _vm.targetComponent.type,
      "availableComponentTypes": _vm.product.availableComponentTypes
    },
    on: {
      "component-type-selected": _vm.changeTargetComponentType
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "component-detail-panel-container"
    }
  }, [(_vm.targetComponent && _vm.targetComponent.type == 'combination' && _vm.availableCombinationTypes.length > 0) ? _c('div', {
    staticClass: "component-detail-panel",
    attrs: {
      "show-second-level-selector": _vm.availableCombinationTypes.length > 1
    }
  }, [_c('div', {
    staticClass: "second-level-selector-container"
  }, [(_vm.availableCombinationTypes.length > 1) ? _c('combination-component-type-selector', {
    attrs: {
      "combinationTypes": _vm.availableCombinationTypes,
      "value": _vm.targetCombinationType
    },
    on: {
      "combination-type-selected": _vm.changeTargetCombinationType
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "component-customization-panel-container"
  }, [_c('div', {
    staticClass: "component-customization-panel"
  }, [_c('component-selector', {
    attrs: {
      "mode": "combination",
      "componentType": _vm.targetCombinationType,
      "componentsInUse": _vm.productSummary.components
    },
    on: {
      "component-selected": _vm.componentSelected
    }
  }), _vm._v(" "), (_vm.targetComponent.variations) ? _c('div', _vm._l((_vm.targetComponent.variations), function(variation) {
    return (_vm.targetComponent.component.isCombination) ? _c('variation-selector', {
      attrs: {
        "name": variation.name,
        "options": variation.options,
        "id": variation.id,
        "value": variation.value
      },
      on: {
        "variation-selected": _vm.variationSelected
      }
    }) : _vm._e()
  })) : _vm._e()])])]) : _vm._e(), _vm._v(" "), _vm._v(" "), _vm._l((_vm.productSummary.components), function(type) {
    return (_vm.targetComponent && _vm.targetComponent.type == type.id) ? _c('div', {
      staticClass: "component-detail-panel",
      attrs: {
        "show-second-level-selector": type.components.length > 1
      }
    }, [_c('div', {
      staticClass: "second-level-selector-container"
    }, [_c('component-position-selector', {
      attrs: {
        "componentType": type.id,
        "componentPositions": type.components,
        "value": _vm.targetComponent.index
      },
      on: {
        "position-selected": _vm.changeTargetComponent
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "component-customization-panel-container"
    }, [_c('div', {
      staticClass: "component-customization-panel"
    }, [(_vm.targetComponent) ? _c('component-selector', {
      attrs: {
        "isRequired": _vm.product.manifest[type.id].min > 0,
        "componentType": _vm.targetComponent.type,
        "index": _vm.targetComponent.index,
        "value": _vm.targetComponent.id
      },
      on: {
        "component-selected": _vm.componentSelected
      }
    }) : _vm._e(), _vm._v(" "), (_vm.targetComponent.variations) ? _c('div', _vm._l((_vm.targetComponent.variations), function(variation) {
      return (!_vm.targetComponent.component.isCombination) ? _c('variation-selector', {
        attrs: {
          "name": variation.name,
          "options": variation.options,
          "id": variation.id,
          "value": variation.value
        },
        on: {
          "variation-selected": _vm.variationSelected
        }
      }) : _vm._e()
    })) : _vm._e()])])]) : _vm._e()
  })], true), _vm._v(" "), _c('div', {
    attrs: {
      "id": "product-info-panel"
    }
  }, [_c('div', {
    attrs: {
      "id": "product-dimension"
    }
  }, [(_vm.product.dimensions.seatHeight > 0) ? _c('div', [_c('span', [_vm._v(_vm._s(_vm.product.dimensions.seatDepth) + "mm座深 / ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.product.dimensions.seatHeight) + "mm座高")])]) : _vm._e(), _vm._v(" "), (_vm.product.dimensions.height > 0) ? _c('div', [_vm._v(_vm._s(_vm.product.dimensions.depth) + "mm長 x " + _vm._s(_vm.product.dimensions.width) + "mm寬 x " + _vm._s(_vm.product.dimensions.height) + "mm高")]) : _vm._e()]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "total-price"
    }
  }, [_vm._v("NT$ " + _vm._s(_vm._f("priceTag")(_vm.productSummary.price)))]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "order-button"
    },
    on: {
      "click": _vm.order
    }
  }, [_vm._v("訂購")])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "component-photo-panel-container"
    }
  }, [_c('component-photo-panel', {
    attrs: {
      "id": "component-photo-panel",
      "productSummary": _vm.productSummary
    },
    on: {
      "component-photo-click": _vm.openLightbox
    }
  })]), _vm._v(" "), _c('div', {
    attrs: {
      "hidden": "",
      "id": "random-button"
    },
    on: {
      "click": _vm.randomProduct
    }
  }, [_vm._v("好手氣")]), _vm._v(" "), (_vm.lightbox.show) ? _c('lightbox', {
    attrs: {
      "photoUrl": _vm.lightbox.photoUrl
    },
    on: {
      "close": _vm.closeLightbox
    }
  }) : _vm._e(), _vm._v(" "), (_vm.modal.show) ? _c('modal', {
    attrs: {
      "mode": _vm.modal.mode
    },
    on: {
      "close": _vm.closeModal
    }
  }, [_c('h3', {
    slot: "header"
  }, [_vm._v(_vm._s(_vm.modal.header))]), _vm._v(" "), _c('span', {
    slot: "body"
  }, [_vm._v(_vm._s(_vm.modal.body))])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-ccddc640!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 199
// module chunks = 5